// Today предназначен только для смены адреса уже назначенной на сегодня доставки Rx4Route.
export function sameDayAddressDate(order, changeAddress, isRx4Route) {
  const policy = order?.same_day_address_change
  return isRx4Route && changeAddress && policy?.allowed === true && order?.deliver?.date === policy.today
    ? policy.today
    : null
}

// Для Today API сохраняет существующие сервис и временное окно; пользователь меняет только адрес.
export function sameDayAddressRequest(order, data, changeAddress, isRx4Route) {
  const today = sameDayAddressDate(order, changeAddress, isRx4Route)
  if (!today || data.date_to_deliver !== today) {
    return null
  }
  return {
    date_to_deliver: today,
    address: data.address ? { ...data.address } : null,
    special_instruction: order.instructions?.recipient ?? '',
  }
}

// Cutoff относится к часам facility, даже если браузер пациента находится в другом поясе.
export function facilityRescheduleCutoffPassed(order, now = new Date()) {
  const cutoff = order?.facility?.customize?.disallow_reschedule_after
  if (!cutoff) {
    return false
  }
  try {
    const localTime = new Intl.DateTimeFormat('en-GB', {
      timeZone: order.facility.time_zone,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(now)
    const minutes = value => {
      const [hour, minute] = value.split(':').map(Number)
      return hour * 60 + minute
    }
    return minutes(localTime) >= minutes(String(cutoff))
  } catch (error) {
    return true
  }
}

// Подпись выдаётся аптекой в ссылке; публичный info не выдаёт право менять адрес.
export function todayAddressToken(search) {
  const token = new URLSearchParams(search).get('today_token')
  return /^[a-f0-9]{64}$/.test(token || '') ? token : null
}

// Rx2Go сохраняет прежний разбор query; подписанные параметры нужны только Rx4Route.
export function trackingIdentity(params, isRx4Route) {
  return isRx4Route ? new URLSearchParams(params).entries().next().value ?? [] : params.split('=')
}

export function trackingPageQuery(params, isRx4Route) {
  if (isRx4Route) {
    return Object.fromEntries(new URLSearchParams(params))
  }
  const [key, value] = params.split('=')
  return { [key]: value }
}
